import {
  Card,
  CardContent,
  Checkbox,
  InputAdornment,
  Paper,
  TextField,
  Typography,
  Button,
  Icon,
  Popover,
  List,
  ListItem,
  Divider
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Search } from "@material-ui/icons";
import GridItem from "components/Grid/GridItem.jsx";
import React from "react";

class BaseTablePageContent extends React.Component {
  state = {
    filterEl: null
  };

  handlePopoverClose = name => {
    this.setState({
      [name]: null
    });
  };

  handlePopoverOpen = (event, name) => {
    this.setState({
      [name]: event.currentTarget
    });
  };

  render() {
    return (
      <Grid container>
        <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: "auto" }}>
          <Card>
            <CardContent>
              <Grid
                container
                justify="space-between"
                style={{ marginBottom: "15px" }}
              >
                <Grid item xs={12} sm={12} md={10} lg={10}>
                  <Typography variant="headline" gutterBottom>
                    {this.props.title}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <Button
                    fullWidth
                    variant="outlined"
                    className="outlinedButton"
                    color="primary"
                    onClick={e => this.handlePopoverOpen(e, "filterEl")}
                  >
                    Filter
                    <Icon>arrow_drop_down</Icon>
                  </Button>
                  <Popover
                    open={Boolean(this.state.filterEl)}
                    anchorEl={this.state.filterEl}
                    onClose={() => this.handlePopoverClose("filterEl")}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center"
                    }}
                  >
                    <List component="nav">
                      <ListItem
                        button
                        onClick={e => this.props.toggleFilterItem(2)}
                      >
                        <Checkbox
                          checked={this.props.filters.includes(2)}
                          onChange={e => this.props.toggleFilterItem(2)}
                        />
                        <Typography
                          variant="subheading"
                          style={{
                            marginLeft: "10px",
                            marginRight: "10px"
                          }}
                        >
                          Assigned
                        </Typography>
                      </ListItem>

                      <Divider />
                      <ListItem
                        button
                        onClick={e => this.props.toggleFilterItem(3)}
                      >
                        <Checkbox
                          checked={this.props.filters.includes(3)}
                          onChange={e => this.props.toggleFilterItem(3)}
                        />
                        <Typography
                          variant="subheading"
                          style={{
                            marginLeft: "10px",
                            marginRight: "10px"
                          }}
                        >
                          Unassigned
                        </Typography>
                      </ListItem>
                      <Divider />
                      <ListItem
                        button
                        onClick={e => this.props.toggleFilterItem(0)}
                      >
                        <Checkbox
                          checked={this.props.filters.includes(0)}
                          onChange={e => this.props.toggleFilterItem(0)}
                        />
                        <Typography
                          variant="subheading"
                          style={{
                            marginLeft: "10px",
                            marginRight: "10px"
                          }}
                        >
                          Request Recieved
                        </Typography>
                      </ListItem>
                      <Divider />
                      <ListItem
                        button
                        onClick={e => this.props.toggleFilterItem(1)}
                      >
                        <Checkbox
                          checked={this.props.filters.includes(1)}
                          onChange={e => this.props.toggleFilterItem(1)}
                        />
                        <Typography
                          variant="subheading"
                          style={{
                            marginLeft: "10px",
                            marginRight: "10px"
                          }}
                        >
                          Request Sent
                        </Typography>
                      </ListItem>
                    </List>
                  </Popover>
                </Grid>
              </Grid>

              <TextField
                id="input-with-icon-textfield"
                fullWidth
                style={{ marginBottom: "3vh" }}
                placeholder="Search by Name, Surname, or Email"
                onChange={this.props.handleSearch}
                label="Search"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  )
                }}
              />

              <Paper style={{ overflowX: "auto" }}>{this.props.children}</Paper>
            </CardContent>
          </Card>
        </GridItem>
      </Grid>
    );
  }
}

export default BaseTablePageContent;



// WEBPACK FOOTER //
// ./src/views/Brokers/components/BaseTablePageContent.jsx